import { pick } from 'ramda'

class BookingUpsertModel {
  constructor({ booking, bookingProductsToDelete, customer }) {
    this.Key = booking.Key
    this.booking = pick(
      ['Key', 'NumberOfPersons', 'CustomerKey', 'NumberOfPersonsPerClassification'],
      booking,
    )
    this.bookingProducts =
      booking.BookingProducts?.filter(p => p.ProductKey).map(bp => new BookingProductPart(bp)) || []
    this.bookingProductsToDelete = bookingProductsToDelete
    this.customer = customer
  }
}

// redundant?
export class BookingProductPart {
  constructor(bookingProduct) {
    this.Key = bookingProduct.Key
    this.ProductKey = bookingProduct.ProductKey
    this.ProductQuantity = bookingProduct.ProductQuantity
    this.Exclusivity = bookingProduct.Exclusivity
    this.FromDateTimeUTC = bookingProduct.FromDateTimeUTC
    this.ProductGroupKey = bookingProduct.ProductGroupKey
    this.ResourceKey = bookingProduct.ResourceKey
    if (!bookingProduct.isSegmentless)
      this.QuantitiesPerClassification = (bookingProduct.QuantitiesPerClassification || []).map(
        c => ({
          ClassificationCode: c.ClassificationCode,
          QuantitiesPerSegment: c.QuantitiesPerSegment.map(s => ({
            Quantity: s.Quantity,
            SegmentCode: s.SegmentCode,
          })),
        }),
      )
    this.Status = 'Active'
    this.BookingProductProperties = bookingProduct.Properties
    // ProductGroupProductKey is needed when creating a bookingProduct from a deal; API needs this to know the junction between products and deals because that contains the price & the junction is not unique on product key with productgroup key
    this.ProductGroupProductKey = bookingProduct.ProductGroupProductKey
  }
}

export default BookingUpsertModel
